module.exports = __webpack_public_path__ + "static/media/gsb-iconSurvey.65bdca5f.svg";